import { API_ENDPOINTS } from '@api/ApiEndpoints';
import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { useHttpClient } from '@hooks/utils/httpConfig';
import {
    OutdatedOSQueryOptions, OutdatedOSSActivitynapshotResponse,
    OutdatedUsedOSSnapshotResponse, OutdatedOSUsersSnapshotResponse
} from './types';
import { getSearchQueryParams } from '@utils/index';

export function useOutdatedOSActivitySnapshotQuery({
    days, OSType, accountType, groupList, locationList, enabled = true,
}: OutdatedOSQueryOptions = {}): UseQueryResult<OutdatedOSSActivitynapshotResponse> {
    const httpClient = useHttpClient();
    const fetchSnapshot = async (): Promise<OutdatedOSSActivitynapshotResponse> => {
        const params = getSearchQueryParams({
            days,
            OSType,
            accountType,
            groupList,
            locationList
        });

        const endpoint = `${API_ENDPOINTS.OUTDATED_OS_ACTIVITY_SNAPSHOT
            }?${params.toString()}`;

        return httpClient.get<OutdatedOSSActivitynapshotResponse>(endpoint)
    };
    return useQuery({ queryKey: ['outdatedOSActivity', days, OSType, accountType, groupList, locationList], queryFn: fetchSnapshot, enabled });
}

export function useOutdatedOSUsedSnapshotQuery({ days, OSType, accountType, groupList, locationList }: OutdatedOSQueryOptions = {}):
    UseQueryResult<OutdatedUsedOSSnapshotResponse> {
    const httpClient = useHttpClient();
    const fetchSnapshot = async (): Promise<OutdatedUsedOSSnapshotResponse> => {
        const params = getSearchQueryParams({
            days,
            OSType,
            accountType,
            groupList,
            locationList
        });

        const endpoint = `${API_ENDPOINTS.OUTDATED_OS_SNAPSHOT
            }?${params.toString()}`;

        return httpClient.get<OutdatedUsedOSSnapshotResponse>(endpoint)
    };
    return useQuery({ queryKey: ['outdatedUsedOS', { days, OSType, accountType, groupList, locationList }], queryFn: fetchSnapshot });
}


export function useOutdatedOSUserTypesSnapshotQuery({ days, OSType, accountType, groupList, locationList }: OutdatedOSQueryOptions = {}):
    UseQueryResult<OutdatedOSUsersSnapshotResponse> {
    const httpClient = useHttpClient();
    const fetchSnapshot = async (): Promise<OutdatedOSUsersSnapshotResponse> => {
        const params = getSearchQueryParams({
            days,
            OSType,
            accountType,
            groupList,
            locationList
        });

        const endpoint = `${API_ENDPOINTS.OUTDATED_OS_USER_TYPES_SNAPSHOT
            }?${params.toString()}`;

        return httpClient.get<OutdatedOSUsersSnapshotResponse>(endpoint)
    };
    return useQuery({ queryKey: ['outdatedOSUserTypes', { days, OSType, accountType, groupList, locationList }], queryFn: fetchSnapshot });
}



